import { ShopifyInstallEnum } from '../enums/modules/routes'

const ShopifyInstall = () =>
  import(/* webpackChunkName: "ShopifyInstall" */ '@/components/testing/ShopifyInstall')

export default [
  {
    path: '/shopifyInstall',
    name: ShopifyInstallEnum.ShopifyInstall,
    component: ShopifyInstall,
    meta: { showSideNav: true }
  }
]
